import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 10001;
`;

export const MenuListWrapper = styled.ul`
  width: 100%;
  min-width: 220px;
  list-style: none;
  padding: 8px 0;
  background-color: #fff;
  border: 1px solid rgba(14, 19, 24, 0.07);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(14, 19, 24, 0.15);
  .list-break {
    border: none;
    border-bottom: 1px solid rgba(64,87,109,.07);
  }
`;

export const MenuListItem = styled.li`
  pointer-events: ${({disabled}) => disabled ? "none" : "auto"};
  opacity: ${({disabled}) => disabled ? ".5" : "1"};
  color: #0e1318;
  font-size: 14px;
  font-weight: 500;
  padding: 12px;
  display: flex;
  align-items: center;
  &:hover {
    background-color: rgba(14,19,24,.07);
    cursor: pointer;
  }
  .anticon {
    font-size: 22px;
    margin-right: 10px;
    color: rgb(14 19 24 / 0.7);
  }
`;
